import { type InferType, boolean, number, object, string, tuple } from "yup";

export const addressSchema = object({
  city: string().defined(),
  country: string().defined(),
  formatted: string().defined(),
  houseNumber: string().defined(),
  inseeCode: string().defined(),
  loc: tuple([number().defined(), number().defined()]).required("Ce champ est obligatoire"),
  postalCode: string().defined(),
  street: string().defined(),
  complementaryAddress: string().optional().max(38),
});

export type TAddressResolver = InferType<typeof addressSchema>;

export const AddressQPVResolver = object({
  isQPV: boolean().defined(),
  QPVName: string().when("isQPV", {
    is: true,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional(),
  }),
  QPVId: string().when("isQPV", {
    is: true,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional(),
  }),
  loc: tuple([number().defined(), number().defined()]).required(),
}).concat(addressSchema);

export type TAddressQPVResolver = InferType<typeof AddressQPVResolver>;
